<template>
    <div class="opening-time-fields">
        <div v-for="field in fields" :key="field.key" class="opening-time-field">
            <label class="form-label" :for="`${prefix}-${field.key}`">{{ field.label }}</label>
            <OrderingTableTimeInput :id="`${prefix}-${field.key}`" :label="field.label" :value="value[field.key]" :disabled="disabled" :align-end="field.key === 'end'"
                :invalid="Boolean(error(field.key))" :described-by="`${prefix}-time-help${error(field.key) ? ` ${prefix}-${field.key}-error` : ''}`"
                @input="$emit('input', { ...value, [field.key]: $event })" />
            <p v-if="error(field.key)" :id="`${prefix}-${field.key}-error`" class="small text-danger mt-1 mb-0">{{ error(field.key) }}</p>
        </div>
        <p :id="`${prefix}-time-help`" class="opening-time-help small mb-0">Format 24 h.</p>
        <p v-if="isOvernight" class="opening-overnight small mb-0">
            {{ value.start === value.end ? 'Créneau de 24 heures, jusqu’au lendemain.' : 'Ce créneau se termine le lendemain.' }}
        </p>
    </div>
</template>

<script>
import OrderingTableTimeInput from "./OrderingTableTimeInput.vue";

export default {
    components: { OrderingTableTimeInput },
    props: {
        value: { type: Object, required: true },
        prefix: { type: String, required: true },
        errorPath: { type: String, required: true },
        errors: { type: Object, default: () => ({}) },
        disabled: { type: Boolean, default: false },
    },
    emits: ["input"],
    data: () => ({ fields: [{ key: "start", label: "Début" }, { key: "end", label: "Fin" }] }),
    computed: {
        isOvernight() {
            const time = /^([01]\d|2[0-3]):[0-5]\d$/;
            return time.test(this.value.start) && time.test(this.value.end) && this.value.end <= this.value.start;
        },
    },
    methods: {
        error(key) { return this.errors[`${this.errorPath}.${key}`]?.[0]; },
    },
};
</script>

<style scoped>
.opening-time-fields { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: .75rem; min-width: 0; width: 100%; max-width: 420px; }
.opening-time-field { min-width: 0; }
.opening-time-help { grid-column: 1 / -1; color: #567382; }
.opening-overnight { grid-column: 1 / -1; color: #426674; }
@media (max-width: 359px) {
    .opening-time-fields { grid-template-columns: minmax(0, 1fr); }
}
</style>
